/*import { io } from "socket.io-client";

// 🔧 MOCK CONFIG
const baseURL = "http://localhost:3001/api";

// 🔐 MOCK TOKEN
const getUserToken = async () => {
  return "mock-token";
};

// 📦 MOCK HEADERS
const createHeader = async () => {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer mock-token",
    },
  };
};

// 🔌 SOCKET (mock simples com token fake)
export const initiateSocketConnection = async () => {
  const token = await getUserToken();

  const socket = io("http://localhost:3001", {
    auth: {
      token,
    },
  });

  return socket;
};

// 👥 MOCK: Lista de usuários disponíveis
export const getAllUsers = async () => {
  return [
    { id: "user1", name: "Maria" },
    { id: "user2", name: "Você" },
    { id: "user3", name: "João" },
  ];
};

// 💬 MOCK: Chat rooms com mensagens
export const getChatRooms = async () => {
  return [
    {
      id: "1",
      members: [
        { id: "user1", name: "Maria" },
        { id: "user2", name: "Você" },
      ],
      messages: [
        {
          id: "msg1",
          senderId: "user1",
          content: "Oi, tudo bem?",
          timestamp: "2025-11-18T12:00:00Z",
        },
        {
          id: "msg2",
          senderId: "user2",
          content: "Tudo sim! E você?",
          timestamp: "2025-11-18T12:01:00Z",
        },
      ],
      updatedAt: "2025-11-18T12:01:00Z",
    },
    {
      id: "2",
      members: [
        { id: "user3", name: "João" },
        { id: "user2", name: "Você" },
      ],
      messages: [
        {
          id: "msg1",
          senderId: "user3",
          content: "Você viu aquilo?",
          timestamp: "2025-11-18T12:05:00Z",
        },
      ],
      updatedAt: "2025-11-18T12:05:00Z",
    },
  ];
};

// 📬 MOCK: Criar nova conversa
export const createChatRoom = async ({ senderId, receiverId }) => {
  return {
    id: Math.random().toString(36).substring(2, 9),
    members: [
      { id: senderId, name: senderId === "user2" ? "Você" : "Outro" },
      { id: receiverId, name: receiverId },
    ],
    messages: [],
    updatedAt: new Date().toISOString(),
  };
};

// 🧾 MOCK: Buscar mensagens da sala (já vem dentro de getChatRooms, mas mantido por compatibilidade)
export const getMessagesOfChatRoom = async (chatRoomId) => {
  const rooms = await getChatRooms();
  const room = rooms.find((r) => r.id === chatRoomId);
  return room?.messages || [];
};

// ✉️ MOCK: Enviar mensagem (somente loga no console)
export const sendMessage = async (messageBody) => {
  console.log("Mensagem enviada (mock):", messageBody);

  // Retorna a própria mensagem com ID fake
  return {
    id: Math.random().toString(36).substring(2, 9),
    ...messageBody,
    timestamp: new Date().toISOString(),
  };
};

// 👤 MOCK: Buscar usuário por ID
export const getUser = async (userId) => {
  const users = await getAllUsers();
  return users.find((u) => u.id === userId);
};

// ❌ MOCK: Pegar conversa entre dois usuários (retorna uma nova)
export const getChatRoomOfUsers = async (firstUserId, secondUserId) => {
  return createChatRoom({ senderId: firstUserId, receiverId: secondUserId });
};

// 👥 MOCK: Obter múltiplos usuários por lista
export const getUsers = async (userIds) => {
  const all = await getAllUsers();
  return all.filter((u) => userIds.includes(u.id));
};*/

// src/services/ChatService.js
// ChatService.js - mock version

/*const currentUserId = "user2"; // "Você"

export const getAllUsers = async () => {
  return [
    { uid: "user1", name: "Maria" },
    { uid: "user2", name: "Você" },
    { uid: "user3", name: "João" }
  ];
};

export const getChatRooms = async () => {
  return [
    {
      id: "1",
      members: [
        { uid: "user1", name: "Maria" },
        { uid: "user2", name: "Você" }
      ],
      messages: [
        {
          id: "msg1",
          sender: "user1",
          message: "Oi, tudo bem?",
          timestamp: "2025-11-18T12:00:00Z"
        },
        {
          id: "msg2",
          sender: "user2",
          message: "Tudo sim, e você?",
          timestamp: "2025-11-18T12:01:00Z"
        },
        {
          id: "msg3",
          sender: "user1",
          message: "Também! 😊",
          timestamp: "2025-11-18T12:02:00Z"
        }
      ],
      updatedAt: "2025-11-18T12:02:00Z"
    },
    {
      id: "2",
      members: [
        { uid: "user3", name: "João" },
        { uid: "user2", name: "Você" }
      ],
      messages: [
        {
          id: "msg1",
          sender: "user3",
          message: "Você viu aquilo?",
          timestamp: "2025-11-18T12:05:00Z"
        },
        {
          id: "msg2",
          sender: "user2",
          message: "Vi sim! Muito doido 😂",
          timestamp: "2025-11-18T12:06:00Z"
        }
      ],
      updatedAt: "2025-11-18T12:06:00Z"
    }
  ];
};

//const mockChatRooms = [ /* ...suas salas com mensagens /// ];

export const getMessagesOfChatRoom = async (chatRoomId) => {
  const rooms = await getChatRooms(); // 👈 chama a função
  const room = rooms.find((room) => room.id === chatRoomId); // ✅ agora sim .find funciona
  return room ? room.messages : [];
};

/*export const getMessagesOfChatRoom = async (chatRoomId) => {
  const rooms = await getChatRooms();
  const room = rooms.find((r) => r.id === chatRoomId);
  return room ? room.messages : [];
};///

export const getUser = async (userId) => {
  const users = await getAllUsers();
  return users.find((u) => u.uid === userId);
};

export const createChatRoom = async (members) => {
  // Simula criação com nome fictício
  const newRoom = {
    id: Date.now().toString(),
    members: [
      { uid: members.senderId, name: members.senderName || "Você" },
      { uid: members.receiverId, name: members.receiverName || "Novo contato" }
    ],
    messages: [],
    updatedAt: new Date().toISOString()
  };
  return newRoom;
};

export const sendMessage = async (messageBody) => {
  return {
    id: Date.now().toString(),
    ...messageBody,
    timestamp: new Date().toISOString()
  };
};

// Socket mock
export const initiateSocketConnection = async () => {
  return {
    emit: (...args) => console.log("[MockSocket] emit:", ...args),
    on: (...args) => console.log("[MockSocket] on:", ...args),
    disconnect: () => console.log("[MockSocket] disconnected")
  };
};*/

// src/services/ChatService.js
import { supabase } from "./SupabaseClient";

// Busca mensagens por session_id usando função do Supabase
export const getMessagesOfChatRoom = async (chatRoomId) => {
  const { data, error } = await supabase
    .rpc("get_messages_by_session", { session_id_input: chatRoomId });

  if (error) {
    console.error("Erro ao buscar mensagens:", error);
    return [];
  }

  return data.map((msg) => ({
    id: msg.id,
    sender: msg.sender,
    message: msg.message,
    timestamp: msg.timestamp,
  }));
};

// Mock de usuários
/*export const getAllUsers = async () => {
  return [
    { uid: "user1", name: "Maria" },
    { uid: "user2", name: "Você" },
    { uid: "user3", name: "João" }
  ];
};*/

export const getAllUsers = async () => {
  const { data, error } = await supabase
    .from("sessions")
    .select("customer_id, contact_name")
    .order("updated_at", { ascending: false });

  if (error) {
    console.error("Erro ao buscar usuários:", error);
    return [];
  }

  // Remove duplicados por customer_id
  const uniqueUsers = new Map();
  data.forEach((item) => {
    if (!uniqueUsers.has(item.customer_id)) {
      uniqueUsers.set(item.customer_id, {
        uid: item.customer_id,
        displayName: item.contact_name || item.customer_id,
      });
    }
  });

  return Array.from(uniqueUsers.values());
};

// Mock de salas de conversa
/*export const getChatRooms = async () => {
  return [
    {
      id: "1",
      members: [
        { uid: "user1", name: "Maria" },
        { uid: "user2", name: "Você" }
      ],
      updatedAt: "2025-11-18T12:02:00Z"
    },
    {
      id: "2",
      members: [
        { uid: "user3", name: "João" },
        { uid: "user2", name: "Você" }
      ],
      updatedAt: "2025-11-18T12:06:00Z"
    }
  ];
};*/

// ChatService.js
/*export const getChatRooms = async () => {
  const { data, error } = await supabase
    .from("chat_sessions_with_metadata") // ou "sessions"
    .select("*");

  if (error) {
    console.error("Erro ao buscar sessões de chat:", error);
    return [];
  }

  return data.map((session) => ({
    id: session.session_id,
    members: [
      { uid: session.customer_id, name: "Paciente" }, // ou session.patient_name
      { uid: "user2", name: "Você" } // currentUser fixo
    ],
    updatedAt: session.updated_at
  }));
};*/

export const getChatRooms = async (currentUserId) => {
  const { data, error } = await supabase
    .from("sessions")
    .select("session_id, customer_id, contact_name, updated_at")
    .order("updated_at", { ascending: false });

  if (error) {
    console.error("Erro ao buscar sessões:", error);
    return [];
  }

  return data.map((session) => ({
    id: session.session_id,
    customerId: session.customer_id,
    members: [
      { uid: session.customer_id, name: session.contact_name || "Contato" },
      { uid: currentUserId, name: "Você" }
    ],
    updatedAt: session.updated_at
  }));
};

// Mock de criação de sala
export const createChatRoom = async (members) => {
  return {
    id: Date.now().toString(),
    members: [
      { uid: members.senderId, name: members.senderName || "Você" },
      { uid: members.receiverId, name: members.receiverName || "Novo contato" }
    ],
    updatedAt: new Date().toISOString()
  };
};

// Mock de conexão de socket
export const initiateSocketConnection = async () => {
  return {
    emit: (...args) => console.log("[MockSocket] emit:", ...args),
    on: (...args) => console.log("[MockSocket] on:", ...args),
    disconnect: () => console.log("[MockSocket] disconnected")
  };
};